import {
  Children,
  FC,
  isValidElement,
  ReactChild,
  ReactFragment,
  ReactNode,
  ReactPortal,
} from 'react';
import { Address } from '@api/profile';

function getListChildren (
  children: ReactNode | ReactNode[],
  name: string,
): (ReactChild | ReactFragment | ReactPortal)[] | null | undefined {
  return Children.map(children, (child): ReactNode => {
    const childElement = child as ReactNode & {
      type: { displayName?: string };
    };

    return childElement.type.displayName === name ? childElement : undefined;
  });
}

function getValidChild<T> (type: FC<T>) {
  return (
    child: React.ReactChild | React.ReactFragment | React.ReactPortal,
  ): child is React.ReactElement<T> => {
    return isValidElement(child) ? child.type === type : false;
  };
}

function getFullAddress(address: Address): string {
  const fields = ['postalCode', 'regionName', 'cityName', 'streetName', 'houseNumber', 'flatNumber'];

  if(address){
    return fields.reduce((result, field, currentIndex) => {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      const value = address[field];

      if(value){
        return result + (result.length ? ' ' : '') + value;
      }

      return result;
    }, '');
  }

  return '';
}

export { getListChildren, getValidChild, getFullAddress };
